import ServiceBase from './ServiceBase';
import store from '../store';

export default class AuthService extends ServiceBase {

    public AuthUser(username: string, password: string, validationCode: string): Promise<any> {
        return this.post('Account/Login', { UserName: username, Password: password, ValidationCode: validationCode }).then((response) => {
            if (response) {
                return store.dispatch('login', response)
                    .then(resp => {
                        return response;
                    });
            }
        })
            .catch(error => {
                throw error;
            });
    }

    public GetUserSecurity(): Promise<any> {
        return this.post('Docketing/GetUserSecurityRoles', { UserName: store.state.user.userName })
            .then((response) => {
                return response;
            })
            .catch(error => console.log('getusersecurity err'));
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/services/Authservice.ts